import { Injectable, inject } from '@angular/core';

import {
    CookieName,
    CookieService,
    NativeAppService,
    NavigationService,
    PageViewContext,
    PageViewDataProvider,
    TrackingData,
} from '@frontend/vanilla/core';
import { Observable, of } from 'rxjs';

import { TrackingValueGettersService } from './tracking-value-getters.service';

@Injectable()
export class DefaultPageViewDataProvider implements PageViewDataProvider {
    private readonly valueGetters = inject(TrackingValueGettersService);
    private readonly navigationService = inject(NavigationService);
    private readonly cookieService = inject(CookieService);
    private readonly nativeAppService = inject(NativeAppService);

    getData(context: PageViewContext = { navigationId: 0, utm: null }): Observable<TrackingData> {
        let data: Record<string, string> = {
            'page.referrer': this.valueGetters.pageReferrer(),
            'page.url': this.valueGetters.locationAbsUrl(),
            'page.host': this.navigationService.location.host(),
            'page.pathQueryAndFragment': this.valueGetters.locationPathQueryAndFragment(),
            'page.name': this.valueGetters.pageName(),
        };

        if (this.nativeAppService.isTerminal) {
            data = {
                ...data,
                ...{
                    'page.terminalId': this.cookieService.get(CookieName.TerminalId),
                    'page.terminalType': this.nativeAppService.applicationName,
                    'page.shopId': this.cookieService.get(CookieName.ShopId) ?? '0',
                },
            };
        }

        if (context?.utm) {
            for (const key in context.utm) {
                if ((context.utm as any)[key]) {
                    data[key.replace('utm_', 'utms.')] = (context.utm as any)[key];
                }
            }
        }

        return of(data);
    }
}
